import { fmtDate } from "../format.ts";
import { safeHref } from "../url.ts";
import type { RtoItem } from "../domain.ts";

// Danh bạ RTO: TOÀN BỘ ứng viên đã log (mọi trạng thái), nhóm theo role —
// khác card benchmark (chỉ đếm Ready + chỉ active stacks).

export type RtoDirectoryModalProps = { items: readonly RtoItem[]; onClose: () => void };

function CandidateRow({ c }: { c: RtoItem }) {
  const href = safeHref(c.profileLink);
  return (
    <tr className={c.status !== "Ready" ? "muted-row" : ""}>
      <td>{href ? <a href={href} target="_blank" rel="noopener">{c.name}</a> : c.name}</td>
      <td>{c.level || "—"}</td>
      <td>{c.eng || "—"}</td>
      <td>{c.recruiter}</td>
      <td>{c.rtoDate ? fmtDate(c.rtoDate) : "—"}</td>
      <td>
        <span className={`rto-status s-${c.status.toLowerCase()}`}>
          {c.status === "Ready" ? "Chờ offer" : c.status}
        </span>
      </td>
    </tr>
  );
}

export function RtoDirectoryModal({ items, onClose }: RtoDirectoryModalProps) {
  const byPos = new Map<string, RtoItem[]>();
  for (const it of items) {
    const list = byPos.get(it.position);
    if (list) list.push(it);
    else byPos.set(it.position, [it]);
  }
  // Nhiều ứng viên trước, cùng số thì theo alphabet.
  const groups = [...byPos.entries()]
    .sort((a, b) => b[1].length - a[1].length || a[0].localeCompare(b[0]));

  const count = (s: string) => items.filter((i) => i.status === s).length;

  return (
    <div
      className="modal-overlay"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div className="modal modal-wide">
        <div className="modal-head">
          <h2>☰ Ứng viên Ready to Offer theo role</h2>
          <button className="btn-icon" type="button" onClick={onClose}>✕</button>
        </div>
        <div className="pos-stats">
          <span className="pos-chip"><b>{items.length}</b> đã log</span>
          <span className="pos-chip green"><b>{count("Ready")}</b> đang chờ offer</span>
          <span className="pos-chip"><b>{count("Offered")}</b> offered</span>
          <span className="pos-chip teal"><b>{count("Hired")}</b> hired</span>
          <span className="pos-chip red"><b>{count("Rejected")}</b> rejected</span>
        </div>

        {groups.length ? groups.map(([pos, list]) => (
          <div key={pos}>
            <h3 className="admin-h3">
              {pos} <small>({list.filter((c) => c.status === "Ready").length} chờ offer / {list.length} tổng)</small>
            </h3>
            <div className="admin-scroll">
              <table className="lb-table admin-table">
                <thead>
                  <tr><th>Candidate</th><th>Level</th><th>ENG</th><th>Recruiter</th><th>RTO date</th><th>Status</th></tr>
                </thead>
                <tbody>
                  {/* Ready lên trước, trong mỗi nhóm thì RTO mới nhất trước. */}
                  {list.slice()
                    .sort((a, b) => (a.status === "Ready" ? 0 : 1) - (b.status === "Ready" ? 0 : 1)
                      || b.rtoDate.localeCompare(a.rtoDate))
                    .map((c) => <CandidateRow c={c} key={c.id} />)}
                </tbody>
              </table>
            </div>
          </div>
        )) : (
          <div className="kpi-empty">Chưa có ứng viên nào được log — dùng nút ＋ Log RTO.</div>
        )}
      </div>
    </div>
  );
}
